import { Popup } from 'devextreme-react';
import { ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from '../../../../../utils/media-query';

export const ReportMicrobiology = ({ visible, setvisible, reporte }) => {
  const { isMedium, isSmall, isXSmall } = useScreenSize();

  const parsearContenidoReporte = (contenido: string | null) => {
    if (!contenido) return null;
    try {
      return JSON.parse(contenido);
    } catch (error) {
      console.error('Error parseando contenido:', error);
      return null;
    }
  };

  return (
    <Popup visible={visible} onHiding={() => setvisible(false)} dragEnabled={false} hideOnOutsideClick={false} showCloseButton={true} showTitle={true} title={`Vista Previa - ${reporte?.Rmr_TipoReporte || ''}`} width={isXSmall ? '100%' : isSmall ? '95%' : isMedium ? '85%' : '70%'} height={isXSmall || isSmall ? '100%' : '80%'}>
      <ToolbarItem
        widget='dxButton'
        toolbar='bottom'
        location='after'
        options={{
          text: 'Cerrar',
          onClick: () => setvisible(false),
        }}
      />
      {reporte && (
        <div style={{ padding: '10px', fontFamily: 'Roboto, sans-serif' }}>
          {/* ENCABEZADO DEL REPORTE */}
          <div
            style={{
              borderBottom: '2px solid #007acc',
              paddingBottom: '15px',
              marginBottom: '20px',
            }}>
            <h4 style={{ margin: 0, color: '#007acc' }}>REPORTE DE MICROBIOLOGÍA - {reporte.Rmr_TipoReporte.toUpperCase()}</h4>
            <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
              <strong>Fecha de generación:</strong> {new Date(reporte.Rmr_FechaGeneracion).toLocaleString()}
              <br />
              <strong>Horas transcurridas:</strong> {reporte.Rmr_HorasTranscurridas}h<br />
              <strong>Número de reporte:</strong> #{reporte.Rmr_NumeroReporte}
            </div>
          </div>

          {/* CONTENIDO DEL GRAM */}
          {reporte.Rmr_ContenidoGram &&
            (() => {
              const gramData = parsearContenidoReporte(reporte.Rmr_ContenidoGram);
              return (
                gramData && (
                  <div style={{ marginBottom: '30px' }}>
                    <h3
                      style={{
                        backgroundColor: '#e3f2fd',
                        padding: '10px',
                        borderLeft: '4px solid #2196f3',
                      }}>
                      EXAMEN DIRECTO (GRAM)
                    </h3>
                    <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                      <p>
                        <strong>Tipo de coloración:</strong> {gramData.TipoColoracion}
                      </p>
                      <p>
                        <strong>Resultado:</strong>
                      </p>
                      <div
                        style={{
                          padding: '10px',
                          backgroundColor: 'white',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          whiteSpace: 'pre-wrap',
                        }}>
                        {gramData.UsarPlantilla
                          ? Object.entries(JSON.parse(gramData.Resultado || '{}')).map(([key, value]) => (
                              <div key={key}>
                                <strong>{key}:</strong> {String(value)}
                              </div>
                            ))
                          : gramData.Resultado}
                      </div>
                      {gramData.Observaciones && (
                        <p>
                          <strong>Observaciones:</strong> {gramData.Observaciones}
                        </p>
                      )}
                    </div>
                  </div>
                )
              );
            })()}

          {/* CONTENIDO DEL CULTIVO */}
          {reporte.Rmr_ContenidoCultivo &&
            (() => {
              const cultivoData = parsearContenidoReporte(reporte.Rmr_ContenidoCultivo);
              return (
                cultivoData && (
                  <div style={{ marginBottom: '30px' }}>
                    <h4
                      style={{
                        backgroundColor: '#fff3e0',
                        padding: '10px',
                        borderLeft: '4px solid #ff9800',
                      }}>
                      CULTIVO
                    </h4>
                    <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                      <p>
                        <strong>Resultado:</strong> {cultivoData.Resultado}
                      </p>
                      {cultivoData.TiempoCrecimiento && (
                        <p>
                          <strong>Tiempo de crecimiento:</strong> {cultivoData.TiempoCrecimiento}h
                        </p>
                      )}
                      {cultivoData.Observaciones && (
                        <p>
                          <strong>Observaciones:</strong> {cultivoData.Observaciones}
                        </p>
                      )}
                    </div>
                  </div>
                )
              );
            })()}

          {/* MICROORGANISMOS IDENTIFICADOS */}
          {reporte.Rmr_ContenidoMicroorganismos &&
            (() => {
              const microData = parsearContenidoReporte(reporte.Rmr_ContenidoMicroorganismos);
              return (
                microData &&
                Array.isArray(microData) &&
                microData.length > 0 && (
                  <div style={{ marginBottom: '30px' }}>
                    <h4
                      style={{
                        backgroundColor: '#e8f5e9',
                        padding: '10px',
                        borderLeft: '4px solid #4caf50',
                      }}>
                      MICROORGANISMOS IDENTIFICADOS
                    </h4>
                    {microData.map((micro, idx) => (
                      <div
                        key={idx}
                        style={{
                          padding: '15px',
                          backgroundColor: '#f8f9fa',
                          borderRadius: '4px',
                          marginBottom: '10px',
                        }}>
                        <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#4caf50' }}>
                          #{micro.Mmo_Orden}: {micro.NombreMicroorganismo}
                        </p>
                        {micro.NombreCientifico && <p style={{ fontStyle: 'italic', color: '#666' }}>{micro.NombreCientifico}</p>}
                        <p>
                          <strong>Recuento:</strong> {micro.Mmo_Recuento}
                        </p>
                        {micro.Mmo_Comentario && (
                          <p>
                            <strong>Comentario:</strong> {micro.Mmo_Comentario}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                )
              );
            })()}

          {/* ANTIBIOGRAMAS */}
          {reporte.Rmr_ContenidoAntibiogramas &&
            (() => {
              const antibiogramaData = parsearContenidoReporte(reporte.Rmr_ContenidoAntibiogramas);
              return (
                antibiogramaData &&
                Array.isArray(antibiogramaData) &&
                antibiogramaData.length > 0 && (
                  <div style={{ marginBottom: '30px' }}>
                    <h4
                      style={{
                        backgroundColor: '#fce4ec',
                        padding: '10px',
                        borderLeft: '4px solid #e91e63',
                      }}>
                      ANTIBIOGRAMA
                    </h4>

                    {/* Agrupar por microorganismo */}
                    {(() => {
                      const grouped = antibiogramaData.reduce((acc, ab) => {
                        const key = `${ab.MicroorganismoOrden}_${ab.MicroorganismoNombre}`;
                        if (!acc[key]) {
                          acc[key] = {
                            orden: ab.MicroorganismoOrden,
                            nombre: ab.MicroorganismoNombre,
                            antibioticos: [],
                          };
                        }
                        acc[key].antibioticos.push(ab);
                        return acc;
                      }, {});

                      return Object.values(grouped).map((grupo: any) => (
                        <div key={grupo.orden} style={{ marginBottom: '20px' }}>
                          <h4
                            style={{
                              backgroundColor: '#fff',
                              padding: '10px',
                              borderLeft: '3px solid #e91e63',
                            }}>
                            Microorganismo #{grupo.orden}: {grupo.nombre}
                          </h4>
                          <table
                            style={{
                              width: '100%',
                              borderCollapse: 'collapse',
                              marginTop: '10px',
                            }}>
                            <thead>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Antibiótico</th>
                                <th style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>MIC</th>
                                <th style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>Interpretación</th>
                              </tr>
                            </thead>
                            <tbody>
                              {grupo.antibioticos.map((ab: any, idx: number) => (
                                <tr key={idx}>
                                  <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    {ab.NombreAntibiotico}
                                    {ab.FamiliaAntibiotico && (
                                      <span
                                        style={{
                                          fontSize: '11px',
                                          color: '#666',
                                          marginLeft: '5px',
                                        }}>
                                        ({ab.FamiliaAntibiotico})
                                      </span>
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      padding: '10px',
                                      border: '1px solid #ddd',
                                      textAlign: 'center',
                                    }}>
                                    {ab.Mab_MIC || '-'}
                                  </td>
                                  <td
                                    style={{
                                      padding: '10px',
                                      border: '1px solid #ddd',
                                      textAlign: 'center',
                                    }}>
                                    <span
                                      style={{
                                        padding: '4px 12px',
                                        borderRadius: '4px',
                                        fontWeight: 'bold',
                                        backgroundColor: ab.Mab_Interpretacion === 'S' ? '#d4edda' : ab.Mab_Interpretacion === 'R' ? '#f8d7da' : '#fff3cd',
                                        color: ab.Mab_Interpretacion === 'S' ? '#155724' : ab.Mab_Interpretacion === 'R' ? '#721c24' : '#856404',
                                      }}>
                                      {ab.Mab_Interpretacion === 'S' ? 'SENSIBLE' : ab.Mab_Interpretacion === 'R' ? 'RESISTENTE' : ab.Mab_Interpretacion === 'I' ? 'INTERMEDIO' : '-'}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ));
                    })()}
                  </div>
                )
              );
            })()}

          {/* PIE DE PÁGINA */}
          <div
            style={{
              marginTop: '40px',
              paddingTop: '20px',
              borderTop: '1px solid #ddd',
              fontSize: '12px',
              color: '#666',
            }}>
            <p>
              <strong>Generado:</strong> {reporte.Rmr_Us_IdCreacion === 0 ? 'Automáticamente' : 'Manualmente'} el {new Date(reporte.Rmr_FechaGeneracion).toLocaleString()}
            </p>
            {reporte.Rmr_ObservacionesReporte && (
              <p>
                <strong>Observaciones:</strong> {reporte.Rmr_ObservacionesReporte}
              </p>
            )}
          </div>
        </div>
      )}
    </Popup>
  );
};
